import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

export type RegisterRequestPayload = {
  customerNumber: string;
  email: string;
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  /**
 * Llama al backend para solicitar el código de registro.
 * Si el server devuelve HTML o texto, seteamos responseType:'text'.
 */
  requestRegisterCode(payload: RegisterRequestPayload): Observable<string> {
    const params = new HttpParams()
      .set('customerNumber', String(payload.customerNumber ?? '').trim())
      .set('email', String(payload.email ?? '').trim());

    return this.http
      .get(environment.register, {
        params,
        observe: 'response',
        responseType: 'text',
        headers: {
          Accept: 'text/plain, application/json, */*',
        },
        // withCredentials: false, // dejalo así salvo que tu backend use cookies
      })
      .pipe(
        map((resp) => {
          const msg = (resp.headers.get('Status') ?? resp.body ?? '')
            .toString()
            .trim();

          if (msg.includes('401')) throw new Error(msg);

          return msg;
        })
      );
  }

  login(username: string, password: string) {
    var body = "username=" + username + '&password=' + password;
    return this.http.post('http://isla.rogiroaceros.com:9980/cgi-bin/wspd_cgi.sh/WService=rogiro/login.r', body, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }

  logout(): void {
    sessionStorage.removeItem('session');
    sessionStorage.removeItem('token');
  }

  loggedIn() {
    return !!sessionStorage.getItem('session');
  }
}
